import React from 'react'
import { Link } from 'react-router-dom';
import imgProductos from '../../assets/img/site/buscamosProductos.gif';
import imgProfesionales from '../../assets/img/site/buscamosProfesionales.gif';
import imgSucursales from '../../assets/img/site/buscamosSucursales.gif';

const Servicios = () => {
	return (
		<section id="servicios">
			<div className="container py-10">
				<div className="row">
					<div className="col-sm-12 mb-5">
						<h2 className="big text-center">¿Qué estás <strong>buscando</strong>?</h2>
					</div>
					<div className="col-sm-4">
						<Link to="/tienda/productos">
							<div className="item-servicios">
								<img src={imgProductos} alt="Productos que trabajamos" />
								<p><strong>Productos</strong>que trabajamos</p>
							</div>
						</Link>
					</div>
					<div className="col-sm-4">
						<Link to="/profesionales">
							<div className="item-servicios">
								<img src={imgProfesionales} alt="Profesionales registrados" />
								<p><strong>Profesionales</strong>registrados</p>
							</div>
						</Link>
					</div>
					<div className="col-sm-4">
						<Link to="/sucursales">
							<div className="item-servicios">
								<img src={imgSucursales} alt="Sucursales cerca tuyo" />
								<p><strong>Sucursales</strong>cerca tuyo</p>
							</div>
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Servicios;
